import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { locationProps } from "../../interfaces";
export interface UserLocationItem {
  location: {
    id: string;
    name: string;
    short_name: string;
    address: string;
    [key: string]: any;
  };
  has_location: boolean;
  is_primary: boolean;
  user_location_id: number | null;
  sequence: string | null;
}

export interface AllLocationsWithStatusState {
  loading: boolean;
  data: {
    status: boolean;
    message: string;
    result: UserLocationItem[];
  } | null;
  error: string | null;
}

// ── Initial State ─────────────────────────────────────────────────────────────

const initialState: AllLocationsWithStatusState = {
  loading: false,
  data: null,
  error: null,
};
const initialLocationsState: locationProps[] = []

export const locationsSlice = createSlice({
  name: "locations",
  initialState: initialLocationsState,
  reducers: {
    setLocations: (state, action: PayloadAction<locationProps[]>) => {
      return action.payload;
    },
    removeLocations: () => {
      return initialLocationsState;
    },
  },
  
});


export const allLocationsWithStatusSlice = createSlice({
  name: "allLocationsWithStatus",
  initialState,
  reducers: {
    setAllLocationsWithStatusLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setAllLocationsWithStatus: (state, action: PayloadAction<AllLocationsWithStatusState["data"]>) => {
      state.loading = false;
      state.data = action.payload;
    },
    setAllLocationsWithStatusError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetAllLocationsWithStatus: () => initialState,
  },
});
export const { setLocations, removeLocations } = locationsSlice.actions;
export const {
  setAllLocationsWithStatusLoading,
  setAllLocationsWithStatus,
  setAllLocationsWithStatusError,
  resetAllLocationsWithStatus,
} = allLocationsWithStatusSlice.actions;

export const selectLocations = (state: RootState) => {
  return state.locations;
};

export default locationsSlice.reducer;
